import { HiOutlineChevronRight } from "react-icons/hi";

export const data = [
  {
    title: "Buy, sell & collect NFTs. Get rewarded for it!",
    description:
      "Trade NFTs, stake Nethty and refer your friends to get rewarded",
    cardImg: "../../assets/img1.jpg",
    cardProfileImg: "../../assets/profileImg.jpg",
    cardTitle: "Trending Collection",
    cardTitleSpan: "animkhatrain",
  },
  {
    title: "Buy, sell & collect NFTs. Get rewarded for it!",
    description:
      "Trade NFTs, stake Nethty and refer your friends to get rewarded",
    cardImg: "../../assets/img1.jpg",
    cardProfileImg: "../../assets/profileImg.jpg",
    cardTitle: "Trending Collection",
    cardTitleSpan: "animkhatrain",
  },
  {
    title: "Buy, sell & collect NFTs. Get rewarded for it!",
    description:
      "Trade NFTs, stake Nethty and refer your friends to get rewarded",
    cardImg: "../../assets/img1.jpg",
    cardProfileImg: "../../assets/profileImg.jpg",
    cardTitle: "Trending Collection",
    cardTitleSpan: "animkhatrain",
  },
  {
    title: "Buy, sell & collect NFTs. Get rewarded for it!",
    description:
      "Trade NFTs, stake Nethty and refer your friends to get rewarded",
    cardImg: "../../assets/img1.jpg",
    cardProfileImg: "../../assets/profileImg.jpg",
    cardTitle: "Trending Collection",
    cardTitleSpan: "animkhatrain",
  },
];

export const mainSectionCard = [
  {
    title: "Screen dfdfdf",
    description: "Nethty is the world's first and largest NFT marketplace",
    color: "#2b2b2b",
  },
  {
    title: "Screen dfdfdf",
    description: "Nethty is the world's first and largest NFT marketplace",
    color: "red",
  },
  {
    title: "Discover, collect, a ",
    description: "Nethty is the world's first and largest NFT marketplace",
    color: "#9DA092",
  },
  {
    title: "Discover, collect, a ",
    description: "Nethty is the world's first and largest NFT marketplace",
    color: "#A3A3B4",
  },
  {
    title: "Discover, collect, a ",
    description: "Nethty is the world's first and largest NFT marketplace",
    color: "#3D4A7A",
  },
  {
    title: "Discover, collect, a ",
    description: "Nethty is the world's first and largest NFT marketplace",
    color: "#165BBA",
  },
];

export const sliderSettings = {
  arrows: true,
  dots: false,
  slidesToShow: 1,
  focusOnselect: false,
  accessability: false,

  responsive: [
    {
      breakpoint: 1280,
      settings: {
        slidesToShow: 1,
        dots: true,
      },
    },

    {
      breakpoint: 900,
      settings: {
        slidesToShow: 1,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        arrows: false,
      },
    },
  ],
};

export const MainsliderSettings = {
  arrows: true,
  dots: true,
  slidesToShow: 3,
  focusOnselect: false,
  accessability: false,
  responsive: [
    {
      breakpoint: 1280,
      settings: {
        slidesToShow: 1,
      },
    },

    {
      breakpoint: 900,
      settings: {
        slidesToShow: 1,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        arrows: false,
      },
    },
  ],
};
